import { ClassValue } from "clsx";

const CloseIcon = ({
  className,
  strokeWidth = 2
} : Props) => {
   return <svg className={className as string} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokeWidth} d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
</svg>;
}

export default CloseIcon;

type Props = {
  className?: ClassValue
  strokeWidth?: number
}